module.exports = __webpack_public_path__ + "img/lobby_hosting_host_control.f7ac3da7.png";